import { motion } from "framer-motion";
import { Film, Camera, Sparkles, Megaphone, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: Camera,
    title: "Fashion Production",
    items: ["Fashion films", "Lookbook videos", "Editorial shoots", "Model portfolios", "Brand identity (Kit)", "Concepts / storyboards"],
  },
  {
    icon: Film,
    title: "Brand & Product Films",
    items: ["Corporate / brand films", "Product video ads", "High-end packshot films", "Testimonial films", "On-location & studio visuals"],
  },
  {
    icon: Megaphone,
    title: "Social Media Content",
    items: ["Trend-based reel shoots", "Cinematic fashion reels", "Celebrity-style portraits", "Short-form content series", "Always-on UGC"],
  },
  {
    icon: Sparkles,
    title: "Influencer & UGC",
    items: ["UGC videos for brands", "Creator campaigns", "Product explainers", "Beauty & lifestyle UGC", "Casting & coordination"],
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-28 md:py-40 bg-[#0c1a14]" data-testid="services-grid">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="text-[11px] uppercase tracking-[0.4em] text-gold">Services</span>
              <span className="h-px w-16 bg-[#264738]" />
            </div>
            <h2 className="font-display text-ivory text-4xl md:text-6xl leading-[1.05] tracking-tight max-w-3xl">
              Hybrid solutions for <span className="italic text-gold">photography</span> + <span className="italic text-gold">videography</span>.
            </h2>
          </div>
          <p className="text-ivory-muted text-sm max-w-md font-light leading-relaxed">
            From the first moodboard to the final delivered cut — we operate as your creative
            partner, not just a vendor.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                className="group relative bg-[#162E24] border border-[#264738] hover:border-gold/60 transition-all duration-500 p-8 md:p-12 hover:-translate-y-1"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between mb-10">
                  <div className="w-14 h-14 border border-[#264738] flex items-center justify-center group-hover:border-gold transition-colors">
                    <Icon className="text-gold" size={22} />
                  </div>
                  <ArrowUpRight className="text-ivory-muted group-hover:text-gold group-hover:rotate-45 transition-all duration-500" size={20} />
                </div>
                <h3 className="font-display text-ivory text-2xl md:text-3xl mb-6">{s.title}</h3>
                <ul className="space-y-2.5">
                  {s.items.map((it) => (
                    <li key={it} className="text-ivory-muted text-sm font-light flex items-center gap-3">
                      <span className="h-px w-3 bg-gold/60" />
                      {it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
